import { useState } from 'react';
import { faqData } from '@/mocks/data';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于91麻豆的常见疑问，这里都有答案
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden border border-background-200/70"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm font-semibold text-foreground-800 pr-4">
                  {item.question}
                </span>
                <i
                  className={`text-lg text-foreground-400 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}